import React from "react";
import { Button } from "react-bootstrap";
import { FaSync } from "react-icons/fa";

const Backup = () => {
  const handleBackup = () => {
    alert("Backup process started...");
  };

  return (
    <div style={{ backgroundColor: "white", padding: "10px" }}>
      {/* Header with white background and blue text */}
      <h5
        style={{
          backgroundColor: "white",
          color: "#004aad",
          padding: "5px",
          fontWeight: "bold",
          margin: "0",
        }}
      >
        Account Backups
      </h5>

      {/* Generate section with background #f2f2f2 */}
      <div style={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
        <span
          style={{
            backgroundColor: "#f2f2f2",
            padding: "5px 10px",
            borderRadius: "5px",
            marginRight: "10px",
            color: "black",
          }}
        >
          Generate
        </span>
        <Button variant="success" onClick={handleBackup}>
          <FaSync className="me-2" />
          Generate New Backup
        </Button>
      </div>
    </div>
  );
};

export default Backup;
